import { Theme } from "@mui/material/styles";

import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  menuItem: {
    padding: "6px 10px",
  },
}));
